import React, { useEffect, useState } from "react";
import { getAboutWhoWeAre } from "../api/companyService";
import { sleep } from "../utils/sleep";
import { Link } from 'react-router-dom';

const AboutWhoWeAre = () => {
  const [aboutWhoWeAre, setAboutWhoWeAre] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
  
      useEffect(() => {
      const fetchAboutWhoWeAre = async () => {
        try {
          // simulate network delay (3 sec)
          //await sleep(3000);
  
          const data = await getAboutWhoWeAre(); // asynchronous call
          setAboutWhoWeAre(data);
        } catch (err) {
          setError("Failed to load who we are.");
        } finally {
          setLoading(false);
        }
      };
  
      fetchAboutWhoWeAre();
      }, []);
    
   
    
     // Error Message
    if (error) {
      return (
        <div className="error-container d-flex flex-column align-items-center justify-content-center py-5">
          <p className="text-danger fs-7">{error}</p>
          <button
            className="btn btn-outline-primary mt-3"
            onClick={() => window.location.reload()}
          >
            Retry
          </button>
        </div>
      );
  }
  
  return (
    <section className="py-4 text-center bg-light">
      {(loading || error) ? (
        <div className="container">
          <h2 className="fw-bold mb-3 placeholder-glow">
            <span className="placeholder col-3 nav-placeholder">&nbsp;</span>
          </h2>
          <p className="small ps-3 placeholder-glow">
             <span className="placeholder col-4 nav-placeholder">&nbsp;</span>
          </p>
          <p className="small ps-3 placeholder-glow">
             <span className="placeholder col-2 nav-placeholder">&nbsp;</span>
          </p>
        </div>
          ) : (
           <div className="container">
          <h2 className="fw-bold mb-3">{aboutWhoWeAre.title}</h2>
          <p className="text-muted">{aboutWhoWeAre.description}</p>
          <Link to={aboutWhoWeAre.link} className="btn btn-outline-theme mt-2">{aboutWhoWeAre.linkText}</Link>
        </div>
          )}
        
      </section>
  );
};

export default AboutWhoWeAre;
